import { useMemo } from "react";
import { useAppSelector } from "@store";

const DIMENSION_R = "dimensions-R";
export const useIsROriginProject = () => {
  const { currentProject } = useAppSelector((state) => state.project);
  const isROriginProject = useMemo(() => {
    if (!currentProject) return false;
    const { dataSource: { name: dataSourceName } = {} } = currentProject;
    return dataSourceName === DIMENSION_R;
  }, [currentProject]);

  return {
    isROriginProject,
  };
};
